/*
 * Copyright 2026 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';

const relationsCard = catalogGraphPlugin
  .getExtension('entity-card:catalog-graph/relations')
  .override({
    factory(originalFactory, { config }) {
      return originalFactory({
        params: {
          loader: () =>
            import('./TableAwareGraphCard').then(m => (
              <m.TableAwareGraphCard {...config} />
            )),
        },
      });
    },
  });

const graphPage = catalogGraphPlugin
  .getExtension('page:catalog-graph')
  .override({
    factory(originalFactory, { config }) {
      return originalFactory({
        params: {
          loader: () =>
            import('./TableAwareGraphPage').then(m => (
              <m.TableAwareGraphPage {...config} initialState={config} />
            )),
        },
      });
    },
  });

export const catalogGraphModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [relationsCard, graphPage],
});
